import gql from 'graphql-tag';
import { SecurityIdentifierField } from 'src/utils/securityMasterCache';

export const getAllLookupValuesQuery = (functionName: string) => gql`
  query {
      allLookupValues(functionName:"${functionName}") {
        tableId
        tableName
        lookupValues
        defaultValue
    }
  }
`;

export const getAllBasketsQuery = () => gql`
  query {
    allBaskets {
      id
      basketId
      basketName
      version
      clientId
      fundId
      status
      orderId
      tenantId
      createdByUser
      createdDate
      modifiedByUser
      modifiedDate
    }
  }
`;

export const getBasketsByClientQuery = (clientId: string) => gql`
  query {
    getBaskets(clientId:"${clientId}") {
      id
      basketId
      basketName
      version
      clientId
      status
      orderId
      tenantId
      createdByUser
      createdDate
      modifiedByUser
      modifiedDate
      basketItemDetails {
        basketNotional
        basketItems {
            id
            basketItemId
            version
            security
            bbgTickerExch
            isin
            sedol
            quantity
            substitutionQuantity
            divRate
            exDate
            recordDate
            price
            fxRate
            tradeId
            eligible
            createdByUser
            createdDate
            inputCurrency
            securityName
            swapCurrency
            notional
            fundId
            settlementDate
            tradeDate
            securityIssueCountry
        }
      }
    }
  }
`;

export const getBasketDetailsQuery = (basketId: string, version: number, currency: string) => gql`
    query {
        basket(basketId: "${basketId}", version:${version}, currency: "${currency}") {
          id
          basketId
          basketName
          version
          clientId
          status
          orderId
          tenantId
          createdByUser
          createdDate
          basketItemDetails {
            basketNotional
            basketItems {
              id
              basketItemId
              version
              security
              bbgTickerExch
              isin
              sedol
              quantity
              substitutionQuantity
              divRate
              exDate
              recordDate
              price
              fxRate
              tradeId
              eligible
              createdByUser
              createdDate
              inputCurrency
              securityName
              swapCurrency
              notional
              fundId
              settlementDate
              securityIssueCountry
          }
        }
        rollupItemDetails {
            basketNotional
            basketItems {
              id
              basketItemId
              version
              security
              bbgTickerExch
              isin
              sedol
              quantity
              substitutionQuantity
              divRate
              exDate
              recordDate
              price
              fxRate
              tradeId
              eligible
              createdByUser
              createdDate
              inputCurrency
              securityName
              swapCurrency
              notional
              fundId
              settlementDate
              securityIssueCountry
          }
        }
     }
  }
`;

export const getNewBasketQuery = (basketId: string, currency: string) => gql`
    query {
        getBasket(basketId: "${basketId}", version:0, currency: "${currency}", override:true) {
        id
        basketId
        basketName
        version
        clientId
        status
        orderId
        tenantId
        createdByUser
        createdDate
        mergedItemDetails {
            basketNotional
            basketItems {
                id
                version
                fundId
                security
                securityName
                bbgTickerExch
                isin
                sedol
                quantity
                substitutionQuantity
                divRate
                exDate
                recordDate
                price
                fxRate
                tradeId
                eligible
                createdByUser
                createdDate
                inputCurrency
                swapCurrency
                notional
                location
                securityIssueCountry
                underlyingBasketItemIds
            }
        }
     }
  }
`;

export const searchSecurityMasterQuery = (keyword: string, field: SecurityIdentifierField) => gql`
  query {
    getSecurities(keyword: "${keyword}", column: "${field}") {
      ticker
      securityName
      cusip
      isin
      sedol
      issueCurrency
      bnySecurityId
      assetClass    
    }
  }
`;

export const processSecuritiesQuery = gql`
  query ProcessSecurities($securities: [SecurityInput]) {
    processSecurities(securities: $securities) {
      ticker
      securityName
      cusip
      isin
      sedol
      issueCurrency
      bnySecurityId
      assetClass
    }
  }
`;
